import Link from '@root/joinroot.com/src/components/core/link';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import Theme from '@root/joinroot.com/src/components/brand/theme';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

export default function FooterLink({
  isInternal, linkText, url,
}) {
  return (
    <Link
      css={styles.link}
      isInternal={isInternal}
      to={url}
    >
      {linkText}
    </Link>
  );
}

const styles = StyleSheet.create({
  link: {
    ...Theme.bodyRegular(),
    display: 'block',
    transition: 'color 150ms cubic-bezier(0.455, 0.03, 0.515, 0.955);',
    lineHeight: '29px',
    color: Colors.rootOrange(),
    ':hover': {
      color: Colors.black(),
    },
    ':focus': {
      color: Colors.black(),
    },
    '.active': {
      color: Colors.black(),
    },
    textDecoration: 'none',
    ...Responsive.md({
      fontSize: 15,
    }),
  },
});

FooterLink.propTypes = {
  isInternal: PropTypes.bool,
  linkText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
